import { ACTIVITY_SUBTYPES, ACTIVITY_SUBTYPES_INSURANCE, ACTIVITY_TYPES, ACTIVITY_TYPES_INSURANCE, } from "../types/activity.types";
import { getLocalizedText } from "./i18n/i18n.utils";
export var mapActivityTypeToString = function (activityTypeId, isInsurance) {
    if (isInsurance === void 0) { isInsurance = false; }
    var activityTypes = isInsurance ? ACTIVITY_TYPES_INSURANCE : ACTIVITY_TYPES;
    return Object.keys(activityTypes).find(function (activityTypeString) { return activityTypes[activityTypeString] === activityTypeId; });
};
export var mapActivitySubtypeToString = function (activitySubtypeId, isInsurance) {
    if (isInsurance === void 0) { isInsurance = false; }
    var result;
    var activitySubtypes = isInsurance
        ? ACTIVITY_SUBTYPES_INSURANCE
        : ACTIVITY_SUBTYPES;
    Object.keys(activitySubtypes).forEach(function (activitySubtypeCategoryString) {
        Object.keys(activitySubtypes[activitySubtypeCategoryString]).forEach(function (activitySubtypeString) {
            if (activitySubtypes[activitySubtypeCategoryString][activitySubtypeString] === activitySubtypeId) {
                result = activitySubtypeString;
                return;
            }
        });
    });
    return result;
};
/**
 * What an owner was shown, as one readable phrase.
 *
 * Composed here rather than stored as a sentence, so the line is read in the
 * reader's own language instead of the language of whoever sent the mail
 * (DEV-3326). Basic information is always part of it: it is what sharing a
 * candidacy means, not a box that can be switched off.
 */
export var getSharedWithOwnerSummary = function (params) {
    var sharedScope = params.sharedScope, sharedProfileLink = params.sharedProfileLink;
    var parts = [
        getLocalizedText("activity.application.shared_with_owner.part.basic"),
    ];
    if (sharedScope === "ASSESSMENT") {
        parts.push(getLocalizedText("activity.application.shared_with_owner.part.assessment"));
    }
    if (sharedProfileLink) {
        parts.push(getLocalizedText("activity.application.shared_with_owner.part.profile_link"));
    }
    return parts.join(", ");
};
